exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/core-js/library/modules/_wks-ext.js
// module id = 156
// module chunks = 0